import dynamic from "next/dynamic";
import Head from 'next/head';
import { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import DatePicker from '@/shared/components/DatePicker';
import ListadoSecciones from './components/ListadoSecciones';
import Notas from "./components/Notas";
import { PagegrowlerFunctions } from '@pagegrowler_nextjs';
import Templates from '@/widgets/index';
import Chartbeat from "@/shared/components/Chartbeat";
import PagegrowlerList from "@/widgets/Listado/Templates/PagegrowlerList";

const Preview = dynamic(() => import('./components/Preview'), { ssr: false });

const EdicionImpresa = (props) => {

    const {
        title = "",
        content,
        properties
    } = { ...props };

    const pagegrowlerFunctions = PagegrowlerFunctions();
    const stringDate = properties.date;

    const stringYear = stringDate.substr(0, 4);
    const stringMonth = stringDate.substr(4, 2);
    const stringDay = stringDate.substr(6, 2);

    let menues = props.menu ? props.menu : [];
    const [open, setOpen] = useState(false);

    function pickDateAction(dayObject) {
        if (typeof window !== 'undefined') {
            const pickedYear = ("0000" + dayObject.year).slice(-4);
            const pickedMonth = ("0" + dayObject.month).slice(-2);
            const pickedDay = ("0" + dayObject.day).slice(-2);

            window.location.href = `/edicion-impresa/${pickedYear}${pickedMonth}${pickedDay}`;
        }
    }

    const [sections, setSections] = useState([]);

    const sortNotesBySection = () => {
        let current;
        const CROP = "3_2_300x200";
        const unsortedSections = [];

        content.map((el) => {
            current = el.sections[0];
            if (!unsortedSections.hasOwnProperty(current._id)) {
                unsortedSections[current._id] = {
                    id: current._id,
                    name: current.name,
                    content: [],
                }
            }

            unsortedSections[current._id].content.push({
                ...el,
                img: pagegrowlerFunctions.getFullImageObject(el, CROP , process.env.NEXT_PUBLIC_IMAGE_DOMAIN)
            });

        });

        const sortedSections = unsortedSections.filter((el) => {
            return el !== null && typeof el !== undefined;
        })

        setSections(sortedSections);
    }
    let dataLDJson =  {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Diario El Litoral",
        "url": "https://www.ellitoral.com",
        "logo": {
          "@type": "ImageObject",
          "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
          "width": 439,
          "height": 60
        },
        "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
      };
    useEffect(() => {
        sortNotesBySection();
    }, []);

    return (
        <>
            <Head>
                <title>{`${stringDay}/${stringMonth}/${stringYear} - Edición Impresa - El Litoral`}</title>
                <meta name="description" property="description" content={`Edición Impresa - El Litoral`} />
                <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />  
                <meta httpEquiv="refresh" content="600" />
            </Head>
            <Chartbeat />
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
            <div className={`${styles['main-container']}`}>
            {!props.preview && <Templates.BannerHorizontalChico bannerId={'top'}/>}
                <div className={`${styles['main-content']}`}>
                    <div className={`${styles['detail-left']}`}>
                        <h2 className={`${styles['title']}`}>Edición Impresa</h2>
                        <div className={`${styles['edition-picker']}`}>
                            <div>
                                <DatePicker
                                    selectedYear={parseInt(stringYear)}
                                    selectedMonth={parseInt(stringMonth)}
                                    selectedDay={parseInt(stringDay)}
                                    pickDateAction={pickDateAction}
                                    minYear={2000}
                                />
                            </div>
                            <div>
                                <Preview date={stringDate} />
                            </div>
                        </div>
                        <div className={`${styles['edition-seccions']}`}>
                            <ListadoSecciones sections={sections} />
                            <Notas sections={sections} />
                        </div>
                        {!props.preview && <Templates.BannerHorizontalChico bannerId={'horizontal1'}/>}
                    </div>
                    <div className={`${styles['detail-right']}`}>
                        <PagegrowlerList url='column-lilanews'/>
                    </div>
                </div>
            </div>
            <div style={{ clear: 'both' }}>
                <Footer />
            </div>
        </>
    )
}

export default EdicionImpresa;